/// <reference types="vite/client" />

/** 简易进销存主路径：显式设置 VITE_SIMPLE_MODE=true 开启；默认保留完整菜单。 */

export function isSimpleMode(): boolean {
  const raw = import.meta.env.VITE_SIMPLE_MODE
  return raw === 'true' || raw === '1'
}

const SIMPLE_MENU_KEYS = new Set([
  'purchase_receipts',
  'sales_outbounds',
  'deliveries',
  'inventory_batches',
  'inventory_movements',
  'stock_takes',
  'transfers',
  'scrap_orders',
  'production_orders',
  'locations',
  'pallets',
  'pricing_rules',
  'customer_levels',
  'products',
  'customers',
  'suppliers',
  'warehouses',
  'units',
  'categories',
  'receivables',
  'payables',
])

const SIMPLE_REPORT_KEYS = new Set(['supplier-statement', 'period-inventory', 'stock-analysis', 'profitability', 'sales-daily', 'location-map', 'scrap-loss', 'average-cost'])

export function showEntityInNav(entityKey: string): boolean {
  if (!isSimpleMode()) return true
  return SIMPLE_MENU_KEYS.has(entityKey)
}

export function showReportInSimpleNav(reportKey: string): boolean {
  if (!isSimpleMode()) return true
  return SIMPLE_REPORT_KEYS.has(reportKey)
}
